import { Component, input } from '@angular/core';
import { FormField, FormRoot, type FieldTree } from '@angular/forms/signals';
import { TranslocoPipe } from '@jsverse/transloco';
import { HlmFieldImports } from '@mb/ui/field';
import { HlmInputImports } from '@mb/ui/input';
import type { OrganizationFormModel } from './organization-form';

@Component({
  selector: 'workforce-organization-form',
  standalone: true,
  imports: [
    FormField,
    FormRoot,
    HlmFieldImports,
    HlmInputImports,
    TranslocoPipe,
  ],
  templateUrl: './organization-form.component.html',
})
export class OrganizationFormComponent {
  readonly organizationForm =
    input.required<FieldTree<OrganizationFormModel>>();
}
